import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LogGetAll } from '../../services';

export const fetchLogGetAll = createAsyncThunk(
    'logGetAll/fetchLogGetAll',
    async ({ search, pageNumber, pageSize }) => {
        const response = await LogGetAll(search, pageNumber, pageSize)
        return response.result
    }
);

const logGetAllSlice = createSlice({
    name: 'logGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLogGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLogGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default logGetAllSlice.reducer;
